export default __webpack_public_path__ + "static/media/explain-traffic-icon-alt.9f31fec7.svg";